export default __webpack_public_path__ + "static/media/coin-lock.6f95604c.svg";